/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TrackCollaboratorNotificationActionData } from './TrackCollaboratorNotificationActionData';
import {
    TrackCollaboratorNotificationActionDataFromJSON,
    TrackCollaboratorNotificationActionDataFromJSONTyped,
    TrackCollaboratorNotificationActionDataToJSON,
} from './TrackCollaboratorNotificationActionData';

/**
 *
 * @export
 * @interface TrackCollaboratorNotificationAction
 */
export interface TrackCollaboratorNotificationAction {
    /**
     *
     * @type {string}
     * @memberof TrackCollaboratorNotificationAction
     */
    specifier: string;
    /**
     *
     * @type {string}
     * @memberof TrackCollaboratorNotificationAction
     */
    type: string;
    /**
     *
     * @type {number}
     * @memberof TrackCollaboratorNotificationAction
     */
    timestamp: number;
    /**
     *
     * @type {TrackCollaboratorNotificationActionData}
     * @memberof TrackCollaboratorNotificationAction
     */
    data: TrackCollaboratorNotificationActionData;
}

/**
 * Check if a given object implements the TrackCollaboratorNotificationAction interface.
 */
export function instanceOfTrackCollaboratorNotificationAction(value: object): value is TrackCollaboratorNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function TrackCollaboratorNotificationActionFromJSON(json: any): TrackCollaboratorNotificationAction {
    return TrackCollaboratorNotificationActionFromJSONTyped(json, false);
}

export function TrackCollaboratorNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackCollaboratorNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': TrackCollaboratorNotificationActionDataFromJSON(json['data']),
    };
}

export function TrackCollaboratorNotificationActionToJSON(value?: TrackCollaboratorNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': TrackCollaboratorNotificationActionDataToJSON(value.data),
    };
}
